(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        var thankYou = document.querySelector('[data-survey-thank-you]');
        var form = document.querySelector('[data-survey-form]');
        var defaultSessionTimeout = 5 * 60 * 1000;

        if (!form) {
            if (thankYou) {
                window.setTimeout(function () {
                    window.location.replace(thankYou.getAttribute('data-reset-url'));
                }, defaultSessionTimeout);
            }

            return;
        }

        var questions = Array.prototype.slice.call(form.querySelectorAll('[data-question]'));
        var progress = document.querySelector('[data-progress]');
        var progressBar = document.querySelector('[data-progress-bar]');
        var progressLabel = document.querySelector('[data-progress-label]');
        var formError = form.querySelector('[data-form-error]');
        var timeoutMessage = document.querySelector('[data-timeout-message]');
        var sessionTimerValue = document.querySelector('[data-session-timer-value]');
        var intro = document.querySelector('[data-intro]');
        var saveUrl = form.getAttribute('data-save-url');
        var resetUrl = form.getAttribute('data-reset-url');
        var tokenInput = form.querySelector('[data-survey-token]');
        var csrfInput = form.querySelector('input[name="_token"]');
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var sessionTimeout = parseInt(form.getAttribute('data-session-timeout'), 10) || defaultSessionTimeout;
        var currentIndex = 0;
        var sessionDeadline = 0;
        var sessionTimer = null;
        var countdownInterval = null;
        var saveDebounceTimer = null;
        var saveQueue = Promise.resolve();
        var saveQueueVersion = 0;
        var resetSessionPromise = null;
        var saveToken = tokenInput ? tokenInput.value : '';
        var autosaveStarted = false;
        var isTransitioning = false;
        var transitionToken = 0;
        var transitionDuration = reducedMotion ? 0 : 170;

        function setProgress(index) {
            var questionNumber = Math.max(1, Math.min(questions.length, index + 1));

            if (progressBar) {
                progressBar.style.width = ((questionNumber / questions.length) * 100) + '%';
            }

            if (progressLabel) {
                progressLabel.textContent = 'Pytanie ' + questionNumber + ' z ' + questions.length;
            }

            if (progress) {
                progress.setAttribute('aria-valuenow', questionNumber);
            }
        }

        function focusQuestion(question) {
            var focusable = question.querySelector('[data-other-field].is-visible input:not([disabled])')
                || question.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled])');

            if (focusable) {
                focusable.focus({preventScroll: true});
            }
        }

        function scrollToSurveyTop() {
            if (!intro) {
                return;
            }

            intro.scrollIntoView({
                behavior: reducedMotion ? 'auto' : 'smooth',
                block: 'start'
            });
        }

        function activateQuestion(targetIndex, direction, immediate) {
            targetIndex = Math.max(0, Math.min(questions.length - 1, targetIndex));

            if (immediate) {
                transitionToken++;
                isTransitioning = false;

                questions.forEach(function (question, index) {
                    question.classList.remove(
                        'is-active',
                        'is-entering-forward',
                        'is-entering-back',
                        'is-leaving-forward',
                        'is-leaving-back'
                    );
                    question.setAttribute('aria-hidden', index === targetIndex ? 'false' : 'true');
                });

                currentIndex = targetIndex;
                questions[currentIndex].classList.add('is-active');
                setProgress(currentIndex);
                return;
            }

            if (isTransitioning || targetIndex === currentIndex) {
                return;
            }

            isTransitioning = true;
            var activeTransitionToken = ++transitionToken;

            var oldQuestion = questions[currentIndex];
            var newQuestion = questions[targetIndex];
            var leavingClass = direction === 'back' ? 'is-leaving-back' : 'is-leaving-forward';
            var enteringClass = direction === 'back' ? 'is-entering-back' : 'is-entering-forward';

            oldQuestion.classList.add(leavingClass);

            window.setTimeout(function () {
                if (activeTransitionToken !== transitionToken) {
                    return;
                }

                oldQuestion.classList.remove('is-active', leavingClass);
                oldQuestion.setAttribute('aria-hidden', 'true');

                currentIndex = targetIndex;
                newQuestion.classList.add('is-active', enteringClass);
                newQuestion.setAttribute('aria-hidden', 'false');
                setProgress(currentIndex);
                scrollToSurveyTop();

                window.setTimeout(function () {
                    if (activeTransitionToken !== transitionToken) {
                        return;
                    }

                    newQuestion.classList.remove(enteringClass);
                    focusQuestion(newQuestion);
                    isTransitioning = false;
                }, reducedMotion ? 0 : 310);
            }, transitionDuration);
        }

        function clientError(question, message) {
            var error = question.querySelector('[data-client-error]') || question.querySelector('.survey-error');

            if (error) {
                error.textContent = message || '';
            }
        }

        function refreshOtherField(question) {
            var otherOption = question.querySelector('[data-other-option]');
            var otherField = question.querySelector('[data-other-field]');

            if (!otherField) {
                return;
            }

            var otherInput = otherField.querySelector('input');
            var needsOther = Boolean(otherOption && otherOption.checked);

            otherField.classList.toggle('is-visible', needsOther);
            otherField.setAttribute('aria-hidden', needsOther ? 'false' : 'true');

            if (otherInput) {
                otherInput.disabled = !needsOther;
            }
        }

        function refreshMultiple(question) {
            var container = question.querySelector('[data-multiple-options]');

            if (!container) {
                return;
            }

            var limitAttribute = container.getAttribute('data-limit');
            var hasLimit = limitAttribute !== null;
            var limit = hasLimit ? parseInt(limitAttribute, 10) : null;
            var checkboxes = Array.prototype.slice.call(container.querySelectorAll('input[type="checkbox"]'));
            var checked = checkboxes.filter(function (checkbox) {
                return checkbox.checked;
            });
            var count = container.querySelector('[data-selection-count]');
            var otherOption = container.querySelector('[data-other-option]');
            var needsOther = otherOption && otherOption.checked;

            checkboxes.forEach(function (checkbox) {
                checkbox.disabled = hasLimit && checked.length >= limit && !checkbox.checked;
            });

            if (count) {
                count.textContent = checked.length;
            }

            refreshOtherField(question);

            var otherInput = question.querySelector('[data-other-field] input');

            if (!needsOther || (otherInput && otherInput.value.trim().length > 0)) {
                clientError(question, '');
            }
        }

        function validateQuestion(question) {
            var limitedOptions = question.querySelector('[data-multiple-options][data-limit]');

            if (limitedOptions) {
                var limit = parseInt(limitedOptions.getAttribute('data-limit'), 10);
                var checked = limitedOptions.querySelectorAll('input[type="checkbox"]:checked').length;

                if (checked > limit) {
                    clientError(question, 'Wybierz maksymalnie ' + limit + ' odpowiedzi.');
                    return false;
                }
            }

            var otherOption = question.querySelector('[data-other-option]');
            var otherInput = question.querySelector('[data-other-field] input');

            if (otherOption && otherOption.checked && (!otherInput || otherInput.value.trim() === '')) {
                clientError(question, 'Uzupełnij odpowiedź.');

                if (otherInput) {
                    otherInput.focus();
                }

                return false;
            }

            clientError(question, '');
            return true;
        }

        function hasAnyAnswer() {
            return Array.prototype.slice.call(form.querySelectorAll('[name^="answers["]'))
                .some(function (input) {
                    if (input.closest('[data-other-field]')) {
                        return false;
                    }

                    if (input.type === 'radio' || input.type === 'checkbox') {
                        return input.checked;
                    }

                    return input.value.trim().length > 0;
                });
        }

        function queueSave() {
            if (!saveUrl || !saveToken || !window.fetch) {
                return;
            }

            var requestVersion = saveQueueVersion;

            saveQueue = saveQueue
                .catch(function () {})
                .then(function () {
                    return (resetSessionPromise || Promise.resolve()).then(function () {
                        if (requestVersion !== saveQueueVersion) {
                            return null;
                        }

                        return window.fetch(saveUrl, {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            credentials: 'same-origin',
                            body: new FormData(form)
                        });
                    });
                })
                .then(function (response) {
                    if (response && response.ok) {
                        return response.json();
                    }

                    return null;
                })
                .catch(function () {
                    return null;
                });
        }

        function scheduleSave(immediate) {
            if (!autosaveStarted) {
                return;
            }

            window.clearTimeout(saveDebounceTimer);

            if (immediate) {
                queueSave();
                return;
            }

            saveDebounceTimer = window.setTimeout(queueSave, 180);
        }

        function startAutosave(immediate) {
            autosaveStarted = true;
            scheduleSave(immediate);
        }

        function cancelPendingSaves() {
            saveQueueVersion++;
            window.clearTimeout(saveDebounceTimer);
            saveQueue = Promise.resolve();
        }

        function resetServerSession() {
            if (!resetUrl || !saveToken || !window.fetch) {
                return;
            }

            var resetData = new FormData();

            if (csrfInput) {
                resetData.append('_token', csrfInput.value);
            }

            resetData.append('survey_token', saveToken);

            resetSessionPromise = window.fetch(resetUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: resetData
            })
                .then(function (response) {
                    return response.ok ? response.json() : null;
                })
                .then(function (payload) {
                    if (payload && payload.token) {
                        saveToken = payload.token;

                        if (tokenInput) {
                            tokenInput.value = saveToken;
                        }
                    }
                })
                .catch(function () {});

            resetSessionPromise.then(function () {
                resetSessionPromise = null;
            });
        }

        function clearSurvey() {
            cancelPendingSaves();
            resetServerSession();
            autosaveStarted = false;

            Array.prototype.slice.call(form.querySelectorAll('[name^="answers["]'))
                .forEach(function (input) {
                    if (input.type === 'radio' || input.type === 'checkbox') {
                        input.checked = false;
                        input.disabled = false;
                    } else {
                        input.value = '';
                    }
                });

            questions.forEach(function (question) {
                question.classList.remove('survey-question--error');
                clientError(question, '');
                refreshMultiple(question);
                refreshOtherField(question);
            });

            if (formError) {
                formError.hidden = true;
                formError.textContent = '';
            }

            if (timeoutMessage) {
                timeoutMessage.hidden = false;
            }

            isTransitioning = false;
            activateQuestion(0, 'back', true);
            scrollToSurveyTop();
        }

        function scheduleSessionCheck(delay) {
            window.clearTimeout(sessionTimer);
            sessionTimer = window.setTimeout(checkSession, Math.max(0, delay));
        }

        function updateSessionTimer() {
            if (!sessionTimerValue) {
                return;
            }

            var remainingSeconds = Math.max(0, Math.ceil((sessionDeadline - Date.now()) / 1000));
            var minutes = Math.floor(remainingSeconds / 60);
            var seconds = String(remainingSeconds % 60).padStart(2, '0');

            sessionTimerValue.textContent = minutes + ':' + seconds;
        }

        function restartSessionTimer() {
            sessionDeadline = Date.now() + sessionTimeout;
            updateSessionTimer();
            scheduleSessionCheck(sessionTimeout + 50);
        }

        function resetExpiredSession() {
            if (Date.now() < sessionDeadline) {
                return false;
            }

            clearSurvey();
            restartSessionTimer();

            return true;
        }

        function checkSession() {
            var remaining = sessionDeadline - Date.now();

            if (remaining > 0) {
                updateSessionTimer();
                scheduleSessionCheck(remaining + 50);
                return;
            }

            if (hasAnyAnswer() || currentIndex !== 0) {
                clearSurvey();
            } else {
                cancelPendingSaves();
                resetServerSession();
            }

            restartSessionTimer();
        }

        questions.forEach(function (question, index) {
            Array.prototype.slice.call(question.querySelectorAll('input[type="radio"]'))
                .forEach(function (radio) {
                    radio.addEventListener('change', function () {
                        refreshOtherField(question);
                        clientError(question, '');
                        startAutosave(false);
                    });
                });

            Array.prototype.slice.call(question.querySelectorAll('[data-multiple-options] input[type="checkbox"]'))
                .forEach(function (checkbox) {
                    checkbox.addEventListener('change', function () {
                        refreshMultiple(question);
                        startAutosave(false);
                    });
                });

            var otherInput = question.querySelector('[data-other-field] input');
            if (otherInput) {
                otherInput.addEventListener('input', function () {
                    refreshOtherField(question);

                    if (otherInput.value.trim().length > 0) {
                        clientError(question, '');
                    }
                });
            }

            Array.prototype.slice.call(question.querySelectorAll('input[type="text"], textarea'))
                .forEach(function (input) {
                    input.addEventListener('input', function () {
                        scheduleSave(false);
                    });
                });

            var next = question.querySelector('[data-next]');
            if (next) {
                next.addEventListener('click', function () {
                    if (resetExpiredSession()) {
                        return;
                    }

                    restartSessionTimer();
                    startAutosave(true);

                    if (!validateQuestion(question)) {
                        return;
                    }

                    if (timeoutMessage) {
                        timeoutMessage.hidden = true;
                    }

                    activateQuestion(index + 1, 'forward', false);
                });
            }

            var previous = question.querySelector('[data-previous]');
            if (previous) {
                previous.addEventListener('click', function (event) {
                    event.preventDefault();

                    if (resetExpiredSession()) {
                        return;
                    }

                    restartSessionTimer();
                    scheduleSave(true);
                    activateQuestion(index - 1, 'back', false);
                });
            }

            refreshMultiple(question);
            refreshOtherField(question);
        });

        form.addEventListener('submit', function (event) {
            if (resetExpiredSession()) {
                event.preventDefault();
                return;
            }

            var invalidQuestion = null;

            questions.some(function (question) {
                if (!validateQuestion(question)) {
                    invalidQuestion = question;
                    return true;
                }

                return false;
            });

            if (invalidQuestion) {
                event.preventDefault();
                activateQuestion(questions.indexOf(invalidQuestion), 'back', false);
                return;
            }

            if (!hasAnyAnswer()) {
                event.preventDefault();

                if (formError) {
                    formError.hidden = false;
                    formError.textContent = 'Odpowiedz przynajmniej na jedno pytanie.';
                }

                clientError(questions[currentIndex], 'Odpowiedz przynajmniej na jedno pytanie.');
                scrollToSurveyTop();
                return;
            }

            window.clearTimeout(sessionTimer);
            window.clearInterval(countdownInterval);
            cancelPendingSaves();

            if (formError) {
                formError.hidden = true;
            }

            var submit = form.querySelector('[data-submit]');
            if (submit) {
                submit.disabled = true;
                submit.innerHTML = 'Wysyłanie…';
            }
        });

        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) {
                checkSession();
            }
        });
        window.addEventListener('focus', checkSession);

        var firstError = form.querySelector('[data-has-error]');
        var initialIndex = firstError ? questions.indexOf(firstError) : 0;

        activateQuestion(initialIndex, 'forward', true);
        restartSessionTimer();
        countdownInterval = window.setInterval(updateSessionTimer, 1000);

        if (firstError) {
            window.setTimeout(function () {
                scrollToSurveyTop();
                focusQuestion(firstError);
            }, 100);
        }
    });
})();
